<script setup lang="ts">
    import AppLogoIcon from '@/components/AppLogoIcon.vue';
    import KeepersLogo from '@/components/icons/KeepersLogo.vue';
    import { Link, usePage } from '@inertiajs/vue3';

    const page = usePage();
    const name = page.props.name;
    const quote = page.props.quote;

    defineProps<{
        title?: string;
        description?: string;
    }>();
</script>

<template>
    <div
        class="relative flex h-dvh w-full items-center justify-center px-8 sm:px-0 lg:max-w-none lg:px-0"
    >
        <div class="w-full lg:max-w-[560px] lg:p-8">
            <div class="mx-auto flex w-full flex-col space-y-6 sm:w-[350px]">
                <KeepersLogo type="dark" />
                <div class="flex flex-col space-y-2">
                    <h1
                        class="text-lg font-medium tracking-tight"
                        v-if="title"
                        >{{ title }}</h1
                    >
                    <p
                        class="text-muted-foreground text-xs"
                        v-if="description"
                        >{{ description }}</p
                    >
                </div>

                <slot />
            </div>
        </div>
        <div
            class="bg-muted relative hidden h-full flex-1 bg-[url('/img/login-bg.jpg')] bg-cover bg-right lg:flex"
        >
        </div>
    </div>
</template>
